

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MessageFormData, LocalizationKeys } from '../classes';
import { DxScrollView } from 'devextreme-vue';

@Component({
    components: {
        DxScrollView,
    }
})
export default class MessageForm
    extends Vue {

    private LocalizationKeys = LocalizationKeys;

    @Prop({ type: Object, required: true})
    private readonly data?: MessageFormData;

    private mounted(): void {
        if (!this.data) { throw new Error('data is not set'); }
    }

    private onCloseClick(): void {
        this.data!.closeForm();
    }
}
